export default function ErrorMessage({ error }) {
  return error
    ? <div className="text-red-500 text-sm py-2">{error.message}</div>
    : null;
};
